const CART_PRODUCTS_FIELD = 'cart_products_novaporta';
let bcUpdateMethod = null; // This method is used for updating cart in diffrent tabs of browser

const executeBcUpdateMethod = () => {
    if (bcUpdateMethod) bcUpdateMethod();
};

export const setBcUpdateMethod = theMethod => {
    bcUpdateMethod = theMethod;
};

export const getStorageData = () => {
    if (!process.client) {
        return [];
    }
    const stringifiedStorage = localStorage?.getItem(CART_PRODUCTS_FIELD);
    const parsedStorage = stringifiedStorage ? JSON.parse(stringifiedStorage) : [];

    if (Array.isArray(parsedStorage)) return parsedStorage;
    else return [];
};

export const getProductServices = productId => {
    let cartItems = getStorageData();

    const targetProduct = cartItems.find(p => p.id === productId);
    if (targetProduct) return targetProduct.services;
    else return [];
};

export const isProductInCart = id => {
    const storage = getStorageData();

    if (storage.find(p => p.id === id)) return true;
    else return false;
};

export const addProductToCart = (id, services, count = 1, extensions, direction = null, slug, analyticProduct) => {
    if (process.client) {
        const product = analyticProduct;
        const contextStore = window?.$nuxt?.$store;
        const settings = contextStore?.state?.global?.globalSettings;
        const currency = settings?.project_currency?.toUpperCase() || '';

        const sendData = {
            currency: currency,
            value: Number(product?.price),
            items: [
                {
                    item_id: product?.productId,
                    item_name: product?.title,
                    discount: product?.discount || 0,
                    item_brand: product?.brand?.name || '',
                    item_category: product?.category?.[0]?.subcategoryTitle || '',
                    item_category2: product?.category?.[1]?.subcategoryTitle || '',
                    item_category3: product?.category?.[2]?.subcategoryTitle || '',
                    item_category4: product?.category?.[3]?.subcategoryTitle || '',
                    item_category5: product?.category?.[4]?.subcategoryTitle || '',
                    price: product?.discount ? Number(product?.old_price) : Number(product?.price),
                    quantity: 1
                }
            ]
        };
        contextStore?.dispatch('google_events/sendItemAddToCartEvent', sendData);
    }
    let newStorage = getStorageData();
    if (!count) count = 1; // insurance of count have value

    if (typeof id === 'number') {
        const foundProduct = newStorage.find(p => p.id === id) || null;

        const product = {
            id: id,
            services: services,
            extensions: extensions,
            direction: direction,
            count: foundProduct ? foundProduct.count + 1 : count,
            slug: slug || ''
        };

        if (foundProduct) newStorage = newStorage.filter(s => s.id !== foundProduct.id);

        if (process.client) {
            localStorage.setItem(CART_PRODUCTS_FIELD, JSON.stringify([...newStorage, product]));
        }
        executeBcUpdateMethod();
    }
};

export const removeFromCart = id => {
    const storage = getStorageData();

    if (id) {
        const newStorage = storage.filter(p => p.id !== id);
        if (process.client) {
            localStorage.setItem(CART_PRODUCTS_FIELD, newStorage);
        }
        executeBcUpdateMethod();
    }
};

export const clearCart = () => {
    if (process.client) {
        localStorage.removeItem(CART_PRODUCTS_FIELD);
    }
    executeBcUpdateMethod();
};

export const updateProductCount = (id, isIncrease = false) => {
    let newStorage = getStorageData();

    newStorage = newStorage
        .map(p => {
            const newCountValue = isIncrease ? p.count + 1 : p.count - 1;
            const newCount = p.id === id ? newCountValue : p.count;
            const excludeProductCondition = p.id === id && p.count === 1 && isIncrease === false;
            const newProduct = {
                ...p,
                count: newCount
            };

            return excludeProductCondition ? null : newProduct; // remove from storage if there is less than 1 count value
        })
        .filter(item => item !== null);

    if (process.client) {
        localStorage.setItem(CART_PRODUCTS_FIELD, JSON.stringify(newStorage));
    }
    executeBcUpdateMethod();
};

export const setService = (id, serviceId, flag) => {
    let newStorage = getStorageData();

    newStorage = newStorage.map(p => {
        let newServices = p.services;

        if (p.id === id && flag) newServices = [serviceId, ...newServices.filter(s => s !== serviceId)];
        else if (p.id === id && !flag) newServices = [...newServices.filter(s => s !== serviceId)];

        return {
            ...p,
            services: newServices
        };
    });

    if (process.client) {
        localStorage.setItem(CART_PRODUCTS_FIELD, JSON.stringify(newStorage));
    }
    executeBcUpdateMethod();
};

// EXTENSIONS

export const getExtensionsOfProduct = productId => {
    let storageProducts = getStorageData();
    let foundExtensions = storageProducts.find(p => p.id === productId)?.extensions || [];

    return foundExtensions;
};

export const getDirectionData = productId => {
    let storageProducts = getStorageData();
    let directionData = storageProducts.find(p => p.id === productId)?.direction || null;

    return directionData;
};

export const getProductExtensionsIds = productId => {
    let storageProducts = getStorageData();
    let newExtensions = [];

    storageProducts.filter(p => {
        if (p.id === productId) {
            if (p.extensions) {
                p.extensions.filter(ex => {
                    if (!newExtensions.includes(ex.product_id))
                        newExtensions.push({
                            id: ex.extension_id,
                            count: ex.multiplicity
                        });
                });
            }
        }
    });

    return newExtensions;
};

export const removeExtensionOfProduct = (productId, extensionId) => {
    let newStorageData = getStorageData();

    newStorageData = newStorageData.map(p => {
        if (p.id === productId) {
            return {
                ...p,
                extensions: p.extensions.filter(p => p.extension_id !== extensionId)
            };
        } else return p;
    });

    if (process.client) {
        localStorage.setItem(CART_PRODUCTS_FIELD, JSON.stringify(newStorageData));
    }
    executeBcUpdateMethod();
};
